import React from 'react';
import './TrustBanner.scss';

const TrustBanner: React.FC = () => {
  const badges = [
    { icon: '🛡️', title: '30-Day Guarantee', text: 'Money back if not satisfied' },
    { icon: '🔒', title: 'Secure Payments', text: 'SSL encrypted checkout' },
    { icon: '📦', title: 'Free Shipping', text: 'On all orders over $100' },
    { icon: '⚡', title: '24/7 Support', text: 'Expert help anytime' }
  ];

  return (
    <section className="trust-banner">
      <div className="container">
        <div className="trust-grid">
          {badges.map((badge, index) => (
            <div key={index} className="trust-item">
              <div className="trust-icon">{badge.icon}</div>
              <div className="trust-content">
                <div className="trust-title">{badge.title}</div>
                <div className="trust-text">{badge.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
